import React, { useEffect, useState } from 'react'
import "../css/HomePageSvgShape.css"
import * as imagesdata from '../imagesdata'
import { FaLongArrowAltRight } from "react-icons/fa";

import { gsap } from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
import SecondaryImageSlideshow from './SecondaryImageSlideshow';
import Reference from './HomePageReference';
gsap.registerPlugin(ScrollTrigger);

const HomePageScrollAnimation = () => {

    const paths = document.querySelectorAll('path.path-anim');
    const [pathData, setPathData] = useState('M 0 0 L 500 0 C 500 599.6 500 677.1 500 750 L 0 750 C 0 205 0 105 0 0 Z');

    useEffect(() => {
        const newPathData = 'M 0 0 L 500 0 C 331 608 485 551 500 750 L 0 750 C 120 281 7 296 0 0 Z';
        setPathData(newPathData);
    }, []);


    paths.forEach(el => {
        const svgEl = el.closest('svg');
        const pathTo = el.dataset.pathTo;
        gsap.timeline({
            scrollTrigger: {
                trigger: svgEl,
                start: "top bottom",
                end: "bottom top",
                scrub: true
            }
        })
            .to(el, {
                ease: 'none',
                attr: { d: pathTo }
            });
    });

    useEffect(() => {

        gsap.fromTo(".content__text",
            { opacity: 0, x: -100 },
            {
                opacity: 1, x: 0, duration: 1, ease: "power2.out",
                scrollTrigger: {
                    trigger: ".content__text",
                    start: "top center",
                    toggleActions: "play none none none",
                }
            }
        );

        gsap.fromTo(".image-clip",
            { opacity: 0, x: 100 },
            {
                opacity: 1, x: 0, duration: 1, ease: "power2.out",
                scrollTrigger: {
                    trigger: ".image-clip",
                    start: "top center",
                    toggleActions: "play none none none",
                }
            }
        );
    }, []);

    return (
        <div>
            <div className="content" style={{ marginTop: "150px" }}>
                <div
                    className="content__bg content__bg--bottom"
                    style={{ backgroundImage: `url(${imagesdata.SvgShapeHeader})` }}
                >
                    <svg
                        className="separator separator--up"
                        width="100%"
                        height="100%"
                        viewBox="0 0 100 10"
                        preserveAspectRatio="none"
                    >
                        <path
                            className="separator__path path-anim"
                            data-path-to="M 0 0 C 35 21 70 0 100 0 L 0 0 Z"
                            vectorEffect="non-scaling-stroke"
                            d="M 0 0 C 37 0 70 0 100 0 L 0 0 Z"
                        />
                    </svg>
                    <svg
                        className="separator separator--down"
                        width="100%"
                        height="100%"
                        viewBox="0 0 100 10"
                        preserveAspectRatio="none"
                    >
                        <path
                            className="separator__path path-anim"
                            data-path-to="M 0 0 C 29 6 78 17 100 0 L 100 10 H 0 Z"
                            vectorEffect="non-scaling-stroke"
                            d="M 0 0 C 18 1 61 9 100 0 L 100 10 H 0 Z"
                        />
                    </svg>
                    <div class="content__title text-light content__title--right">
                        <span class="content__title-pre"><span className='content__title-pre-outline'>Akıllı Yollar</span></span>
                        <h2 class="content__title-main">Akıcı Trafik</h2>
                    </div>
                </div>
                <div className="content__sides">
                    <div className="content__text">
                        <h2>Akıllı ve Verimli <br /> Trafik Çözümleri</h2>
                        <p>
                        Traflux olarak temel ilkemiz, trafiği daha akıcı ve verimli hale getirmektir. 
                        Her sistemimiz, yenilikçi teknolojiler ve özenle tasarlanmış algoritmalarla çalışarak 
                        araç ve yaya akışını en doğru şekilde yönetir. Veriye dayalı karar mekanizmalarımızla, 
                        hem şehir içi trafiği optimize ediyor hem de herkes için daha güvenli ve dengeli bir 
                        yol deneyimi sunuyoruz.
                        </p>
                    </div>
                    <svg className="image-clip" style={{ width: '500px', height: '750px', display: "flex", justifyContent: "left" }} viewBox="0 0 500 750">
                        <defs>
                            <clipPath id="shape1">
                                <path class="path-anim" data-path-to="M 0 0 L 500 0 C 331 608 485 551 500 750 L 0 750 C 120 281 7 296 0 0 Z" d="M 0 0 L 500 0 C 500 599.6 500 677.1 500 750 L 0 750 C 0 205 0 105 0 0 Z" />
                            </clipPath>
                        </defs>
                        <image
                            href={imagesdata.SvgShape}
                            clipPath="url(#shape1)"
                            style={{ width: '600px', height: '900px' }}
                        />
                    </svg>
                </div>
            </div>

            <SecondaryImageSlideshow />

            <div className="content" style={{ marginTop: "150px" }}>
                <div
                    className="content__bg content__bg--bottom"
                    style={{ backgroundImage: `url(${imagesdata.SvgShapeContactUs})` }}
                >
                    <svg
                        className="separator separator--up"
                        width="100%"
                        height="100%"
                        viewBox="0 0 100 10"
                        preserveAspectRatio="none"
                    >
                        <path
                            className="separator__path path-anim"
                            data-path-to="M 0 0 C 17 21.6 35.2 1.2 50 1.4 C 65.2 1.5 83 21.6 100 0 L 0 0 Z"
                            vectorEffect="non-scaling-stroke"
                            d="M 0 0 C 23 0 35 0 50 0 C 65 0 74 0 100 0 L 0 0 Z"
                        />
                    </svg>
                    <svg
                        className="separator separator--down"
                        width="100%"
                        height="100%"
                        viewBox="0 0 100 10"
                        preserveAspectRatio="none"
                    >
                        <path
                            className="separator__path path-anim"
                            data-path-to="M 24 0 C 33 0 37 10 49 10 C 61 10 65 0.1 74 0 C 83 0 90 10 100 0 L 100 10 L 0 10 L 0 0 C 9 7 15 0.1 24 0 Z"
                            vectorEffect="non-scaling-stroke"
                            d="M 24 0 C 33 0 30 0 49 0 C 64 0 65 0.1 74 0 C 83 0 82 0 100 0 L 100 10 L 0 10 L 0 0 C 11 0 15 0.1 24 0 Z"
                        />
                    </svg>
                    <div class="content__title text-light content__title--center">
                        <h2 class="content__title-contact-us">İLETİŞİM</h2>
                        <h6 class="content__title-contact-us-description">
                            Ürünlerimizi satın almak veya herhangi bir durum için bizimle iletişime geçebilirsiniz.
                        </h6>
                        <div className='content__title-contact-us-button'>
                            <a href='/iletisim'>
                                <button className='error-footer-button-1 error-footer-button-2' style={{ justifyContent: "center" }}>
                                    <span style={{ display: "flex", alignItems: "center" }}>Bize Ulaşın <FaLongArrowAltRight size={20} style={{ margin: "0 0 0 5px" }} /></span>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className='grid-image-text-header'>
                <h3 className='grid-image-text'>- Referanslarımız -</h3>
            </div>

            <Reference />
        </div>
    )
}

export default HomePageScrollAnimation